import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  SCHEMES_ANALYTES,
  POST_RESULT,
  UPDATE_RESULT,
  GET_RESULT,
  GET_STATISTICS,
  POST_SERELOGY_VALUES,
  GET_SERELOGY_VALUES,
  GET_ANALYTE_RESULT_PARTICIPANT,
  GET_MICRO_RESULT_DATA,
  POST_MICRO_RESULT,
  POST_MICRO_VALUE,
  GET_MICRO_STATISTICS,
  GET_MICRO_VALUE_LIST,
  GET_ANALYTE_DATA,
  GET_RESULT_ANALYTE_DATA,
  UPDATE_MICRO_RESULT,
  GET_QUALITATIVE_ASSIGN,
  SAVE_STATISTICS_STATUS_REQUEST,
} from "./actionTypes";

import {
  getSchemeAnalytesListSuccess,
  getSchemeAnalytesListFail,
  postResultSuccess,
  postResultFail,
  updateResultSuccess,
  updateResultFail,
  getResultsListSuccess,
  getResultsListFail,
  getStatisticsListSuccess,
  getStatisticsListFail,
  postValuesSuccess,
  postValuesFail,
  getResultValuesSuccess,
  getResultValuesFail,
  getAnalyteResultParticipantSuccess,
  getAnalyteResultParticipantFail,
  getmicroresultdataSuccess,
  getmicroresultdataFail,
  postMicroResultSuccess,
  postMicroResultFail,
  postMicroValueSuccess,
  postMicroValueFail,
  getMicroStatisticsListSuccess,
  getMicroStatisticsListFail,
  getMicroValueListSuccess,
  getMicroValueListFail,
  getAnalytesDataSuccess,
  getAnalytesDataFail,
  getResultAnalyteDataSuccess,
  getResultAnalyteDataFail,
  updateMicroResultSuccess,
  updateMicroResultFail,
  getQualitativeAssignSuccess,
  getQualitativeAssignFail,
  saveStatisticsStatusSuccess,
  saveStatisticsStatusFailure,
} from "./actions";

//Include Both Helper File with needed methods
import {
  getSchemeAnalytesList,
  postResult,
  updateResult,
  getResultsList,
  getStatisticsList,
  addSereologyValues,
  getSereologyValues,
  getAnalyteResultParticipantlist,
  getmicroresultdatalist,
  postMicroResult,
  postMicroValue,
  apiGetMicroStatisticsList,
  getMicroValueListApi,
  getAnalytesDataApi,
  getResultAnalyteDataApi,
  updateMicroResult,
  apiGetQualitativeAssign,
  saveStatisticsStatusApi,
} from "../../helpers/django_api_helper";

function* fetchAnalytesScheme(action) {
  try {
    const { id, page, limit, filters } = action.payload;
    const response = yield call(
      getSchemeAnalytesList,
      id,
      page,
      limit,
      filters,
    );
    // console.log("ResponseSaga :", response.data);
    yield put(getSchemeAnalytesListSuccess(response.data));
  } catch (error) {
    yield put(getSchemeAnalytesListFail(error));
  }
}

// POST RESULT
function* onPostResult(object) {
  try {
    const response = yield call(
      postResult,
      object.payload.result,
      object.payload.id,
    );
    yield put(postResultSuccess(response));
  } catch (error) {
    yield put(postResultFail(error));
  }
}
/////////////////////////

function* onUpdateResult(action) {
  try {
    const { result, id, callback } = action.payload;
    const response = yield call(updateResult, result, id);
    const payload = response?.data || response;

    if (payload?.status === 200) {
      yield put(updateResultSuccess(payload));
    } else {
      yield put(updateResultFail(payload));
    }

    if (callback) callback(payload); // ✅ Call it
    return payload;
  } catch (error) {
    const errPayload = error?.response?.data || { message: "Unexpected error" };
    yield put(updateResultFail(errPayload));
    if (action.payload.callback) action.payload.callback(errPayload);
    return errPayload;
  }
}

/////////////////////////
function* onPostValues(object) {
  try {
    const response = yield call(
      addSereologyValues,
      object.payload.result,
      object.payload.id,
    );
    yield put(postValuesSuccess(response));
  } catch (error) {
    yield put(postValuesFail(error));
  }
}
////////////////

function* fetchResultList(action) {
  try {
    const { id, page, limit, filters } = action.payload;
    const response = yield call(getResultsList, id, page, limit, filters);

    if (response.data.length > 0) {
      const updated_at = response.data[0].updated_at; // Extract updated_at

      yield put(
        getResultsListSuccess({
          results: response.data,
          updated_at: updated_at, // Send updated_at to reducer
        }),
      );
    } else {
      yield put(getResultsListFail("No results found"));
    }
  } catch (error) {
    yield put(getResultsListFail(error));
  }
}

////////////////
function* fetchValuesList(action) {
  try {
    const { id, round_id } = action.payload; // Extract values from the action payload
    const response = yield call(getSereologyValues, id, round_id);

    yield put(getResultValuesSuccess(response.data)); // Dispatch success action with the data
  } catch (error) {
    // Dispatch failure action with the error
    yield put(getResultValuesFail(error));
  }
}

////////////////
function* fetchStatisticsList(object) {
  try {
    const response = yield call(getStatisticsList, object.payload);

    yield put(getStatisticsListSuccess(response.data));
  } catch (error) {
    yield put(getStatisticsListFail(error));
  }
}



function* fetchAnalyteResultParticpant(action) {
  try {
    const { schemeId, roundId, analyteId } = action.payload; // add schemeId

    console.log("schemeId:", schemeId, "roundId:", roundId, "analyteId:", analyteId);

    const response = yield call(
      getAnalyteResultParticipantlist,
      schemeId,   
      roundId,    
      analyteId   
    );

    yield put(getAnalyteResultParticipantSuccess(response.data.data || []));
  } catch (error) {
    console.error("Error fetching data:", error);
    yield put(getAnalyteResultParticipantFail(error));
  }
}
function* fetchMicroResultList(action) {
  try {
    console.log("Fetching micro result list with payload:", action.payload);

    const response = yield call(getmicroresultdatalist, action.payload);

    console.log("API response:", response);

    // Extract instruments and reagents from microbiology
    const instruments = response.microbiology
      ? Array.from(
          new Set(
            response.microbiology
              .filter((item) => item.equipment_name)
              .map((item) => item.equipment_name),
          ),
        )
      : [];

    const reagents = response.microbiology
      ? Array.from(
          new Set(
            response.microbiology
              .filter((item) => item.reagent_name)
              .map((item) => item.reagent_name),
          ),
        )
      : [];

    console.log("Instruments:", instruments);
    console.log("Reagents:", reagents);

    // Dispatch success action
    yield put(
      getmicroresultdataSuccess({
        instruments, // ✅ updated from microbiology
        reagents, // ✅ updated from microbiology
        organisms: response.organisms || [],
        antibiotics: response.antibiotics || [],
        results: response.results || [],
      }),
    );
  } catch (error) {
    console.error("Error fetching micro result list:", error);
    yield put(getmicroresultdataFail(error?.response?.data || error.message));
  }
}

/////////////
function* onPostMicroResult(object) {
  try {
    const response = yield call(
      postMicroResult,
      object.payload.result,
      object.payload.id,
    );
    yield put(postMicroResultSuccess(response));
  } catch (error) {
    yield put(postMicroResultFail(error));
  }
}

function* onPostMicroValue(action) {
  try {
    const payload = action.payload; // { user_id, scheme_id, round_id, data }

    // Call the axios helper with the full payload and round_id
    const response = yield call(postMicroValue, payload, payload.round_id);

    // Dispatch success with response data
    yield put(postMicroValueSuccess(response.data));
  } catch (error) {
    yield put(postMicroValueFail(error));
  }
}

function* fetchMicroStatisticsList(object) {
  try {
    const response = yield call(apiGetMicroStatisticsList, object.payload);
    yield put(getMicroStatisticsListSuccess(response));
  } catch (error) {
    yield put(getMicroStatisticsListFail(error));
  }
}
function* fetchMicroValueList(action) {
  try {
    const roundId = action.payload;
    const response = yield call(getMicroValueListApi, roundId);
    // send only the array
    yield put(getMicroValueListSuccess(response.data));
  } catch (error) {
    yield put(getMicroValueListFail(error?.response?.data || error.message));
  }
}

function* fetchAnalytesData(action) {
  try {
    const { id, page, limit, filters } = action.payload;
    const response = yield call(getAnalytesDataApi, id, page, limit, filters);
    // console.log("ResponseSaga :", response.data);
    yield put(getAnalytesDataSuccess(response.data));
  } catch (error) {
    yield put(getAnalytesDataFail(error));
  }
}

function* fetchResultAnalytesData(action) {
  try {
    const { id, page, limit, filters } = action.payload;
    const response = yield call(
      getResultAnalyteDataApi,
      id,
      page,
      limit,
      filters,
    );
    // console.log("ResponseSaga :", response.data);
    yield put(getResultAnalyteDataSuccess(response.data));
  } catch (error) {
    yield put(getResultAnalyteDataFail(error));
  }
}

function* onUpdateMicroResult(object) {
  try {
    const response = yield call(
      updateMicroResult,
      object.payload.result,
      object.payload.id,
    );
    yield put(updateMicroResultSuccess(response));
  } catch (error) {
    yield put(updateMicroResultFail(error));
  }
}

function* fetchQualitativeAssign(action) {
  try {
    const response = yield call(apiGetQualitativeAssign, action.payload);
    yield put(getQualitativeAssignSuccess(response));
  } catch (error) {
    yield put(getQualitativeAssignFail(error));
  }
}
function* saveStatisticsStatus(action) {
  try {
    const response = yield call(saveStatisticsStatusApi, action.payload);
    yield put(saveStatisticsStatusSuccess(response.data));
  } catch (error) {
    yield put(
      saveStatisticsStatusFailure(error?.response?.data || error.message),
    );
  }
}
function* AnalyteSchemeSaga() {
  yield takeEvery(SCHEMES_ANALYTES, fetchAnalytesScheme);
  yield takeEvery(SAVE_STATISTICS_STATUS_REQUEST, saveStatisticsStatus);
  yield takeEvery(POST_RESULT, onPostResult);
  yield takeEvery(UPDATE_RESULT, onUpdateResult);
  yield takeEvery(POST_SERELOGY_VALUES, onPostValues);
  yield takeEvery(GET_RESULT, fetchResultList);
  yield takeEvery(GET_SERELOGY_VALUES, fetchValuesList);
  yield takeEvery(GET_STATISTICS, fetchStatisticsList);
  yield takeEvery(GET_QUALITATIVE_ASSIGN, fetchQualitativeAssign);
  yield takeEvery(GET_ANALYTE_RESULT_PARTICIPANT, fetchAnalyteResultParticpant);
  yield takeEvery(GET_MICRO_RESULT_DATA, fetchMicroResultList);
  yield takeEvery(POST_MICRO_RESULT, onPostMicroResult);
  yield takeEvery(POST_MICRO_VALUE, onPostMicroValue);
  yield takeEvery(GET_MICRO_STATISTICS, fetchMicroStatisticsList);
  yield takeEvery(GET_MICRO_VALUE_LIST, fetchMicroValueList);
  yield takeEvery(GET_ANALYTE_DATA, fetchAnalytesData);
  yield takeEvery(GET_RESULT_ANALYTE_DATA, fetchResultAnalytesData);
  yield takeEvery(UPDATE_MICRO_RESULT, onUpdateMicroResult);
}

export default AnalyteSchemeSaga;
